import { b } from './chunk-IMSWER4T.js';

var a=(t=>(t[t.paused=0]="paused",t[t.active=1]="active",t))(a||{});var i=class extends b{URL="validation-models";async duplicate(e){return (await this._client.post("/validation-models/duplicate",e)).data}async changeStatus(e,t){return (await this._client.post(`/validation-models/${t===1?"active":"inactive"}`,{validation_models:e})).data}async validateProduct(e){return (await this._client.post(`/products/${e}/fields/validate`)).data}};

export { a, i as b };
//# sourceMappingURL=chunk-P3O2KXD5.js.map
//# sourceMappingURL=chunk-P3O2KXD5.js.map